import { Box } from "@mui/material";
import { AnalyticsEvents, analytics } from "common/analytics";
import { useTranslation } from "common/locales";
import { useCallback, useState } from "react";
import { FarmPerformanceCards } from "./AssessmentCards";
import AssessmentsSection from "./AssessmentsSection";
import type { InsightCategory } from "./InsightDetailDialog";
import InsightDetailDialog from "./InsightDetailDialog";
import InsightsSection from "./InsightsSection";
import ReportsSection from "./ReportsSection";
import YieldInsightsCards from "./YieldInsightsCards";

export function FarmInsights() {
  const { t } = useTranslation();
  const [detailCategory, setDetailCategory] = useState<InsightCategory | null>(
    null
  );

  const handleOpenDetail = useCallback((category: InsightCategory) => {
    analytics.track(AnalyticsEvents.INSIGHT_DETAIL_OPENED, { category });
    setDetailCategory(category);
  }, []);

  return (
    <>
      <Box sx={{ paddingTop: "env(safe-area-inset-top)" }} />

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          minHeight: "100%",
          paddingTop: "20px",
          paddingBottom: "20px",
          overflowX: "hidden",
        }}
      >
        <InsightsSection title={t("insights.farmPerformance.title")}>
          <YieldInsightsCards>
            <FarmPerformanceCards onOpenDetail={handleOpenDetail} />
          </YieldInsightsCards>
        </InsightsSection>

        <InsightsSection title="Environmental Impact">
          <AssessmentsSection onOpenDetail={handleOpenDetail} />
        </InsightsSection>

        <InsightsSection title="Reports">
          <ReportsSection />
        </InsightsSection>
      </Box>

      <InsightDetailDialog
        open={detailCategory !== null}
        category={detailCategory}
        onClose={() => setDetailCategory(null)}
      />
    </>
  );
}
